<div class="ls-overlay">
  <div class="ls-card">

    <!-- Logo box -->
    <div class="ls-logo-box">
      <mat-icon class="ls-logo-icon">sports_soccer</mat-icon>
    </div>

    <!-- Spinner -->
    <mat-progress-spinner
      mode="indeterminate"
      diameter="44"
      class="ls-spinner">
    </mat-progress-spinner>

    <!-- Text -->
    <div class="ls-text">
      <h3 class="ls-title">CanchasYa.cl</h3>
      <p class="ls-subtitle">{{ loadingSubtitle() }}</p>
    </div>

  </div>
</div>
